module.exports = ".centered-content {\r\n    margin: auto;\r\n    text-align: center;\r\n}\r\n.mt5{\r\n    margin-top:.5em;\r\n}"